module.exports = __webpack_public_path__ + "media/images/flags/4x3/nzl-9aa89d3e3548e2e9ed37b781eed084ae.svg";